// extracted by mini-css-extract-plugin
export var avgPriceBanner = "avgPriceBanner__qzy9";